var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRollReverse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "436.8px",
    height: "566.9px",
    viewBox: "0 0 436.8 566.9",
    enableBackground: "new 0 0 436.8 566.9",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#000000",
    strokeMiterlimit: 10,
    d: "M37.9,552"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D2D2",
    stroke: "#878787",
    strokeMiterlimit: 10,
    d: "M49.3,546.1l353.2-90.8c0.2,0,0.3-0.2,0.3-0.4l-1.1-69.3V37.4h-0.2 c-1.1-10.8-8.4-18.2-19.8-18.2c-1.8,0-3.5,0.2-5.1,0.6c-0.2-0.2-0.3-0.3-0.3-0.3L38,88.9c-0.4,0.1-0.4,0.5-0.1,0.7 c3.7,2.2,10.1,11.9,11.7,16.8v0.1l-0.8,439.2C48.9,546,49.1,546.2,49.3,546.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#878787",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    d: "M49.6,111.8c0,12.6-5.9,22.7-13.2,22.7 s-13.2-10.2-13.2-22.7c0-9.9,5.9-22.7,13.2-22.7S49.6,99.2,49.6,111.8z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRollReverse);
export default __webpack_public_path__ + "static/media/roll_reverse.bbfe45917156643e24e66940fac4e844.svg";
export { ForwardRef as ReactComponent };